import React from "react";
import PropTypes from "prop-types";
import Client from "./Client";

function ClientList({ partners, selectedClientLens, resetSelectedClientLens, isReadOnly }) {
  return partners.map((partner, index) => (
    <Client
      key={index}
      index={index}
      partner={partner}
      selectedClientLens={selectedClientLens}
      resetSelectedClientLens={resetSelectedClientLens}
      isReadOnly={isReadOnly}
    />
  ));
}

ClientList.propTypes = {
  partners: PropTypes.array.isRequired,
  selectedClientLens: PropTypes.object.isRequired,
  resetSelectedClientLens: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};

export default ClientList;
